module.exports = __webpack_public_path__ + "img/f1.5ee852bc.png";